import React from "react";
import "./Footer.css";
import Instagram from "../../src/assets/instagram.png";
import Logo from '../../src/assets/logo.png'
const Footer = () => {
  return (
    <div className="Footer-container">
      <hr />
      <div className="footer">
        <div className="social-links">

          <img src={Instagram} alt="" />

        </div>
        <div className="logo-f">
            <img src={Logo} alt="" />
        </div>
      </div>
      <div className="blur blur-f"></div>
      <div className="blur blur-f"></div>
    </div>
  );
};

export default Footer;
